import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7130ed20&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7130ed20')) {
      api.createRecord('7130ed20', component.options)
    } else {
      api.reload('7130ed20', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7130ed20&", function () {
      api.rerender('7130ed20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/pages/_poll/index.vue"
export default component.exports